// src/types/output-policy.ts
var FAIL_CLOSED_PLACEHOLDER = "Detailed rationale unavailable; manual review required.";
function isFailClosed(text) {
  return text.trim() === FAIL_CLOSED_PLACEHOLDER;
}
export {
  FAIL_CLOSED_PLACEHOLDER,
  isFailClosed
};
//# sourceMappingURL=output-policy.js.map